// material-ui

import { Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import Avatar from 'components/@extended/Avatar';
import { useSelector } from 'store';



// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const theme = useTheme()
  const setting: any = useSelector((state) => state.organization)?.logo;
 

  return (

    <Typography variant="h5" className="mainlogo">
      <Avatar
        sx={{
          border: '1px solid',
              borderColor: theme.palette.primary.main,
              bgcolor: 'transparent',
          objectFit: 'contain'
        }}
        src={
          setting?.[0]?.path
            ? process.env.REACT_APP_FILE_URL + setting?.[0]?.path
            : `data:${setting?.[0]?.mimetype};base64,${setting?.[0]?.file}`
        }
      />
    </Typography>
  );
};

export default LogoIcon;
